import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  useTheme,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export default function Headers({
    scrollToRef,
    sectionRefs
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <AppBar position="static">
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Box
                component="img"
                src="/images/logo.png"
                alt="Logo"
                sx={{
                  maxWidth: '160px',
                  height: 'auto',
                  display: 'block',
                }}
              />
            </Box>

            {isMobile ? (
              <>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <MenuIcon />
                </IconButton>
              </>
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                  <Button color="inherit" onClick={() => scrollToRef(sectionRefs.homeRef)}>
                    Home
                  </Button>
                  <Button color="inherit" onClick={() => scrollToRef(sectionRefs.companyRef)}>
                    Company
                  </Button>
                  <Button color="inherit" onClick={() => scrollToRef(sectionRefs.companyRef)}>
                    Products
                  </Button>
                  <Button color="inherit" onClick={() => scrollToRef(sectionRefs.contactRef)}>
                    Contact
                  </Button>                                                      
              </Box>
            )}
          </Toolbar>

          {/* Inline mobile menu */}
          {isMobile && menuOpen && (
            <Box sx={{ display: "flex", flexDirection: "column", p: 2 }}>
                <Button color="inherit" fullWidth sx={{ justifyContent: "flex-start" }} onClick={() => scrollToRef(sectionRefs.homeRef)}>
                    Home
                </Button>
                <Button color="inherit" fullWidth sx={{ justifyContent: "flex-start" }} onClick={() => scrollToRef(sectionRefs.companyRef)}>
                    Company
                </Button>
                <Button color="inherit" fullWidth sx={{ justifyContent: "flex-start" }} onClick={() => scrollToRef(sectionRefs.companyRef)}>
                    Products
                </Button>
                <Button color="inherit" fullWidth sx={{ justifyContent: "flex-start" }} onClick={() => scrollToRef(sectionRefs.contactRef)}>
                    Contact
                </Button>                                                
            </Box>
          )}
        </AppBar>
    );
}